export default "__VITE_ASSET__CFrr3EJJ__"